module.exports = __webpack_public_path__ + "static/media/prick_HMPG_header_image_06_1400.c2443c2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/prick_HMPG_header_image_06_1400.jpg
// module id = 341
// module chunks = 0